import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class ReportThresholdNotification extends Notification {
  icon() {
    return 'fas fa-shield-alt';
  }

  href() {
    const subject = this.attrs.notification.subject();
    const isAuthor = subject && app.session.user && subject.id() === app.session.user.id();

    if (isAuthor) return '#';

    const taskId = this.attrs.notification.content().taskId;

    return `${app.route('yingtaoReviewTasks')}?task=${encodeURIComponent(taskId)}`;
  }

  content() {
    const subject = this.attrs.notification.subject();
    const isAuthor = subject && app.session.user && subject.id() === app.session.user.id();

    return app.translator.trans(
      isAuthor
        ? 'yingtao-forum-homepage.forum.notifications.report_threshold_author'
        : 'yingtao-forum-homepage.forum.notifications.report_threshold_reviewer'
    );
  }

  excerpt() {
    return null;
  }
}
